import React from 'react'
import './Resources.css'
import Footer from '../Footer'

import '../../App.css'




function Resources() {
    return (
        <div className='resources-container'>
            <div className='resources-picture'>
                <br /><br /><br /><br /><br /><h1 className='resources-header'>Resources</h1><br /><br /><br /><br /><br /><br /><br />
            </div>

            <br /><br /><br />


            <div class="values-section">
                <h2 className='values-header'>Helpful Links</h2>
                <br />
                <div class="values-container">
                    <div class="value-item">
                        <a href="https://one.iu.edu/" target="_blank" rel="noopener noreferrer"><h3>One.IU</h3></a>
                        <p>One.IU is the place where you will find almost anything you need, whether you want to see your schedule, register for classes, pay your fees, and much more!</p>
                    </div>
                    <div class="value-item">
                        <a href="https://beinvolved.indiana.edu/" target="_blank" rel="noopener noreferrer"><h3>beINvolved</h3></a>
                        <p>beINvolved contains every single organization, so that it is easy for you to find and show interest in the ones that interest you. </p>
                    </div>
                    <div class="value-item">
                        <a href="https://app.joinhandshake.com/login" target="_blank" rel="noopener noreferrer"><h3>Handshake</h3></a>
                        <p>Handshake is your stop for everything regarding work opportunities, including internship and full-time roles. </p>
                    </div>
                    
                </div>
                {/* <button class="learn-more">Learn More</button> */}
            </div>
            <br /><br /><br />
            <div class="other-resources-section">
                <h2 className='values-header'>Other Helpful Links</h2>
                <br />
                <div class="other-resources-container">
                    <div class="value-item">
                        <a href="https://www.adobe.com/acrobat/online.html" target="_blank" rel="noopener noreferrer"><h3 class="white-text">Adobe Acrobat (free with IU account)</h3></a>
                    </div>
                    <div class="value-item">
                        <a href="https://southeast.iu.edu/student-central/grades/calculate-gpa.html" target="_blank" rel="noopener noreferrer"><h3 class="white-text">IU GPA Calculator</h3></a>
                    </div>
                    <div class="value-item">
                        <a href="https://mobile.print.iu.edu/myprintcenter/" target="_blank" rel="noopener noreferrer"><h3 class="white-text">IU MyPrintCenter</h3></a>
                    </div>
                    <div class="value-item">
                        <a href="https://sisjee.iu.edu/essweb-prd/web/sas/student/init/" target="_blank" rel="noopener noreferrer"><h3 class="white-text">IU Appointment Scheduler</h3></a>
                    </div>
                    <div class="value-item">
                        <a href="https://registrar.indiana.edu/information/building-codes.html" target="_blank" rel="noopener noreferrer"><h3 class="white-text">IU Building Abbreviations</h3></a>
                    </div>
                    <div class="value-item">
                        <a href="https://gradedistribution.registrar.indiana.edu/content/index.php" target="_blank" rel="noopener noreferrer"><h3 class="white-text">IU Grade Distributions</h3></a>
                    </div>
                    <div class="value-item">
                        <a href="https://hrms.iu.edu/psc/PH1PRD_PUB/EMPLOYEE/HRMS/c/HRS_HRAM_FL.HRS_CG_SEARCH_FL.GBL?FOCUS=Applicant&SiteId=1" target="_blank" rel="noopener noreferrer"><h3 class="white-text">IU Jobs</h3></a>
                    </div>
                    <div class="value-item">
                        <a href="https://iu.zoom.us/profile" target="_blank" rel="noopener noreferrer"><h3 class="white-text">IU Zoom</h3></a>
                    </div>
                </div>
                {/* <button class="learn-more">Learn More</button> */}
            </div>
            
            
                
        </div>
    )
}

export default Resources